import * as React from "react";
import MainContent from "./MainContent/MainContent";
import TopBar from "./TopBar/TopBar";
import http from "../../../services/api/utilities/http";

const OverviewDashboard = () => {
  const [workspaceData, setWorkspaceData] = React.useState()

  const getWorkspaceData = (workspace) => {
    http.get('dashboard/workspace/' + workspace.value)
      .then(res => {
        setWorkspaceData(res.data.data)
      })
      .catch(err=>{
        console.log(err.response)
      })
  }

  return (
    <>
      <div className={'container-fluid'}>
        <TopBar onSelectWorkspace={getWorkspaceData} />
        <MainContent workspaceData={workspaceData} />
      </div>
    </>
  )
}

export default OverviewDashboard